export default {
  higher: 'Higher value',
  lower: 'Lower value or zero',
  empty: 'No data'
}
